import { render, staticRenderFns } from "./Acupoint.vue?vue&type=template&id=2da292d8&scoped=true"
import script from "./Acupoint.vue?vue&type=script&lang=js"
export * from "./Acupoint.vue?vue&type=script&lang=js"
import style0 from "./Acupoint.vue?vue&type=style&index=0&id=2da292d8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da292d8",
  null
  
)

export default component.exports